import React from "react";
import styled from "styled-components";
import { Flex } from "../Flex";
import { Rounded } from "../../theme/Rounded";
import { Spacing } from "../../theme/Spacing";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { AtiraIcon } from "../AtiraIcon";
import { ThemeType } from "../../theme/Theme";
import { TextWithTruncated } from "../TextWithTruncated";
import { Text } from "../Text";

const NameContainer = styled(Flex)<{ isEmptyText: boolean }>`
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  flex-wrap: nowrap;
  gap: ${Spacing.s};
  padding: ${Spacing.xs};
  padding-inline-start: ${({ isEmptyText }) =>
    isEmptyText ? Spacing.xs : Spacing.s};
  border-radius: ${({ isEmptyText }) =>
    isEmptyText ? Rounded.circle : Rounded.md};
  width: ${({ isEmptyText }) => (isEmptyText ? "fit-content" : "100%")};
  margin-inline-start: ${({ isEmptyText }) => (isEmptyText ? "auto" : "0")};

  p {
    color: ${({ theme }) => theme.white} !important;
  }

  > p,
  > div {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const NamePreview = styled(Flex)<{ $hoverColor: keyof ThemeType }>`
  background-color: ${({ theme }) => theme.white};
  border-radius: ${Rounded.circle};
  height: 2rem;
  width: 2rem;
  flex: 0 0 2rem;
  color: ${({ theme }) => theme.main};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme, $hoverColor }) => theme[$hoverColor]};
    color: ${({ theme }) => theme.white};
  }
`;

type TableActionableCellPreviewProps = {
  text?: string;
  onPreview: VoidFunction;
  hoverColor?: keyof ThemeType;
};

export const TableActionableCellPreview: React.FC<
  TableActionableCellPreviewProps
> = ({ text, onPreview, hoverColor = "main" }) => {
  return (
    <NameContainer className="actionable-cell" isEmptyText={!text?.length}>
      {text ? <TextWithTruncated length={30}>{text}</TextWithTruncated> : null}
      <NamePreview $hoverColor={hoverColor} onClick={onPreview}>
        <AtiraIcon icon={faEye} size="lg" />
      </NamePreview>
    </NameContainer>
  );
};
